import { render, staticRenderFns } from "./url-presenter.vue?vue&type=template&id=54030cad&scoped=true&"
import script from "./url-presenter.vue?vue&type=script&lang=js&"
export * from "./url-presenter.vue?vue&type=script&lang=js&"
import style0 from "./url-presenter.vue?vue&type=style&index=0&id=54030cad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54030cad",
  null
  
)

export default component.exports